"use strict";

module.exports = function (val) {
  return val && typeof val.isValid == 'function' && val.isValid();
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/helpers/is-valid-moment-object.js
// module id = 448
// module chunks = 64